import React, { useState, useEffect } from "react";
import UserService from "../../services/UserService";
import { Link } from "react-router-dom";

const ListUser = () => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
    retrieveUsers();
  }, []);

  const retrieveUsers = () => {
    UserService.getAll()
      .then((response) => {
        setUsers(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const setActiveUser = (user, index) => {
    setCurrentUser(user);
    setCurrentIndex(index);
  };

  const refreshList = () => {
    retrieveUsers();
    setCurrentUser(null);
    setCurrentIndex(-1);
  };

  console.log("Current User:" + JSON.stringify(currentUser));

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          {" "}
          <h4>Users List</h4>
        </div>
        <div className="col-md-4">
          <div className="input-group mb-3">
            <button
              type="button"
              className="btn btn-outline-primary pull-right"
            >
              <Link
                to={"/admin/user/add"}
                className="nav-link"
              >
                Add User
              </Link>
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>

              <th scope="col">Edit</th>
            </tr>
          </thead>
          <tbody>
            {users &&
              users.map((users, index) => (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>{users.name}</td>
                  <td>{users.email}</td>

                  <td>
                    <Link
                      to={"/admin/user/" + users.id}
                      className="btn btn-outline-warning"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListUser;
